module.exports = __webpack_public_path__ + "static/media/hn.4938f675.svg";